export default "__VITE_ASSET__e984538a__"